import * as React from 'react';
import { IAppSettings } from '../types';

const defaultSettings: IAppSettings = {
	apiBase: '',
	blogId: 1,
	postType: 'post',
	multiPostType: false,
	availablePostTypes: [],
	postTypeOptions: [],
	postsPerPage: 12,
	filtersToShow: [],
	showSearch: true,
	layout: 'default',
	searchTitle: 'Search by keyword',
	initSelectedTax: {},
	addFiltersToUrl: true,
	addPageToUrl: false,
	addSearchToUrl: false,
	paginationType: 'numbered_pagination',
	postAuthor: '',
	i18n: {
		filters: 'Filters',
		type: 'Type',
		searchPlaceholder: 'Enter keywords...',
		clearSearch: 'Clear search',
		search: 'Search',
		noResultsTitle: 'No Results Found',
		noResultsDesc: "There are no results for the filters you've selected.",
		clearFilters: 'Clear Filters',
		showMore: 'Show More',
		result: 'result',
		results: 'results',
		resultFor: 'result for',
		resultsFor: 'results for',
	},
	element: null,
};

const SettingsContext = React.createContext<IAppSettings>(defaultSettings);

const useSettingsContext = () => React.useContext(SettingsContext);

export { SettingsContext, useSettingsContext };
